import { render, staticRenderFns } from "./DocumentNumber.vue?vue&type=template&id=4748ef64&scoped=true&"
import script from "./DocumentNumber.vue?vue&type=script&lang=js&"
export * from "./DocumentNumber.vue?vue&type=script&lang=js&"
import style0 from "./DocumentNumber.vue?vue&type=style&index=0&id=4748ef64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748ef64",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4748ef64')) {
      api.createRecord('4748ef64', component.options)
    } else {
      api.reload('4748ef64', component.options)
    }
    module.hot.accept("./DocumentNumber.vue?vue&type=template&id=4748ef64&scoped=true&", function () {
      api.rerender('4748ef64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/DocumentNumber.vue"
export default component.exports